import { TagUtil } from '../../tags/utils/TagUtil';
import { TopContentDTO } from '../dtos/TopContent.dto';
import { TopContentModel } from '../models/TopContent.model';

export class TopContentUtil {
  public static mapToViewModel(dto: TopContentDTO): TopContentModel {
    return {
      id: dto.id,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      access: dto.access,
      status: dto.status,
      type: dto.feedItemType,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      publishedOn: dto.publishedOn,
      views: dto.views,
    };
  }
}
